module.exports = __webpack_public_path__ + "static/media/logo_white.e23d813d.svg";